/**
 * ThemeToggle · v2.6.7 batch J — DISABLED.
 * Light theme was retired. This stub renders nothing so existing JSX that
 * still imports + renders <ThemeToggle/> continues to compile without
 * breaking the header layout.
 */
export default function ThemeToggle() {
  return null;
}
